import { ReactElement, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './Loader.scss';

export type LoaderProps = {
  text?: string;
  alignSelfCenter?: boolean;
  overlay?: boolean;
  fillBackground?: boolean;
  overlayRoot?: boolean;
};

export const Loader = ({
  text,
  alignSelfCenter = false,
  overlay = false,
  fillBackground = false,
  overlayRoot = false
}: LoaderProps): ReactElement => {
  const { t } = useTranslation();
  const loadingText = text ?? t('general.loading', 'Lädt...');

  useEffect(() => {
    document.body.classList.toggle('no-scroll', overlayRoot);
    return () => document.body.classList.remove('no-scroll');
  }, [overlayRoot]);

  return (
    <Box
      className={`custom-loader ${overlay ? 'overlay' : ''}  ${
        fillBackground ? 'fill-background' : ''
      } ${overlayRoot ? 'overlay-root' : ''}`}>
      <CircularProgress
        aria-label={loadingText}
        className={`loader-spinner ${alignSelfCenter ? 'align-self-center' : ''}`}
      />
      <Box className='loading-text'>{loadingText}</Box>
    </Box>
  );
};
